import type { CreatorSegmentRefreshStatus } from '../generated/social-media/metapicSocialMediaAPIDocumentation.schemas'

/**
 * A segment whose membership is still being materialised — a dynamic one mid-refresh, or a static
 * one being seeded from its criteria for the first time. There is nothing to read back until the
 * refresh settles.
 */
export const isSegmentGenerating = (status?: CreatorSegmentRefreshStatus | null): boolean =>
  status === 'pending' || status === 'running'
